import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
import { ToasterService } from 'angular2-toaster';
import { ReportsService } from '../../../services/index';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';

@Component({
    selector: 'client-ref-change-report-tab',
    templateUrl: './clientRefChangeReport.component.html'
})
export class ClientRefChangeReportComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    suppressPaging = false;
    scrollTimeout: any;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: '',
        orderDir: 'desc'
    };

    filterData: any = {
        from_date: new Date(),
        to_date: new Date(),
        branch_id: '',
        search_name: '',
        first_ref_id: '',
        last_ref_id: ''
    };

    reportData: any[] = [];
    columns: any[] = [];
    allColumns: any[] = [];
    toggleCol: any[] = [];
    usertype: string = '';
    initialized = false;

    branchList: any[] = [];
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;

    referenceList: any[] = [];
    firstRefCtrl: FormControl;
    filteredFirstRef: Observable<any[]>;
    lastRefCtrl: FormControl;
    filteredLastRef: Observable<any[]>;
    firstRefFilteredList: any[] = [];
    lastRefFilteredList: any[] = [];

    constructor(
        private reportsService: ReportsService,
        private toasterService: ToasterService,
        private store: Store<any>
    ) {}

    ngOnInit() {
        let that = this;
        this.branchCtrl = new FormControl();
        this.firstRefCtrl = new FormControl();
        this.lastRefCtrl = new FormControl();

        this.filteredFirstRef = this.firstRefCtrl.valueChanges
            .startWith(null)
            .map(val => (typeof val === 'string' && val) ? that.filterRef(val) : that.referenceList.slice());
        this.filteredLastRef = this.lastRefCtrl.valueChanges
            .startWith(null)
            .map(val => (typeof val === 'string' && val) ? that.filterRef(val) : that.referenceList.slice());

        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (!_.isEmpty(res)) {
                that.referenceList = res;
                that.firstRefCtrl.setValue(that.firstRefCtrl.value);
                that.lastRefCtrl.setValue(that.lastRefCtrl.value);
            }
        });

        this.store.select(fromCommonStore.getAuth).take(1).subscribe((auth: any) => {
            if (auth['islogin']) {
                that.usertype = auth['usertype'];
                if (auth['usertype'] != 'Super_Admin' && auth['usertype'] != 'Admin' && auth['usertype'] != 'Accounts') {
                    that.filterData.branch_id = auth['branch_id'];
                    that.branchCtrl.disable();
                }
                that.initialized = true;
                that.getReports();
            }
        });

        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (!_.isEmpty(res.data)) {
                that.branchList = res.data;
                that.filteredBranch = that.branchCtrl.valueChanges
                    .startWith(null)
                    .map(val => val ? that.filterBranch(val) : that.branchList.slice());
            }
        });
    }

    ngOnChanges() {
        if (this.active && this.initialized) {
            this.getReports();
        }
    }

    filterBranch(val: any) {
        if (!val || typeof val !== 'string') { return this.branchList.slice(); }
        return this.branchList.filter(b => b.branch_name.toLowerCase().includes(val.toLowerCase()));
    }

    displayBranchFn(branch_id: any) {
        if (!branch_id) { return ''; }
        let item = _.find(this.branchList, { 'branch_id': branch_id });
        return item ? item.branch_name : '';
    }

    filterRef(val: string) {
        let escaped = _.escapeRegExp(val);
        return this.referenceList.filter(r => new RegExp(escaped, 'gi').test(r.name));
    }

    displayRefFn(ref_id: any) {
        if (!ref_id) { return ''; }
        let item = _.find(this.referenceList, { 'ref_id': ref_id });
        return item ? item.name : '';
    }

    onSearch() {
        this.page.offset = 0;
        this.getReports();
    }

    onReset() {
        this.filterData = {
            from_date: new Date(),
            to_date: new Date(),
            branch_id: '',
            search_name: '',
            first_ref_id: '',
            last_ref_id: ''
        };
        this.branchCtrl.reset();
        this.firstRefCtrl.reset();
        this.lastRefCtrl.reset();
        this.reportData = [];
        this.columns = [];
        this.page.count = 0;
    }

    pageCallback(pageInfo: any) {
        if (this.suppressPaging) { return; }
        if (pageInfo.offset !== undefined) {
            this.page.offset = pageInfo.offset;
        } else if (pageInfo.page !== undefined) {
            this.page.offset = pageInfo.page - 1;
        }
        this.getReports();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.page.offset = 0;
        this.getReports();
    }

    onChangePage(event: any) {
        this.page.offset = (event.page - 1);
        this.getReports();
    }

    onColumnToggle(columns: any[]) {
        this.columns = [...columns];
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { clearTimeout(this.scrollTimeout); }
        this.scrollTimeout = setTimeout(() => { this.suppressPaging = false; }, 100);
    }

    getReports() {
        let that = this;
        let params: any = {
            page_type: 'clientRefChangeReport',
            from_date: moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: moment(this.filterData.to_date).format('YYYY-MM-DD'),
            branch_id: this.filterData.branch_id || '',
            search_name: this.filterData.search_name || '',
            first_ref_id: this.filterData.first_ref_id || '',
            last_ref_id: this.filterData.last_ref_id || '',
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`
        };

        this.isLoadMask = this.reportsService.getReports(params).then(function (res: any) {
            that.loadingIndicator = false;
            that.reportData = res.data || [];
            that.page.count = res.totCnt || 0;
        }).catch(function (err: any) {
            that.loadingIndicator = false;
            that.toasterService.pop('error', 'Error', 'Failed to load report');
        });
    }

    onExcelExport() {
        let params: any = {
            page_type: 'clientRefChangeReport',
            from_date: moment(this.filterData.from_date).format('YYYY-MM-DD'),
            to_date: moment(this.filterData.to_date).format('YYYY-MM-DD'),
            branch_id: this.filterData.branch_id || '',
            search_name: this.filterData.search_name || '',
            first_ref_id: this.filterData.first_ref_id || '',
            last_ref_id: this.filterData.last_ref_id || '',
            start: '0',
            limit: '99999'
        };

        this.isLoadMask = this.reportsService.getReports(params).then(function (res: any) {
            let data: any[] = res.data || [];
            let cols: any[] = res.columns || [];
            if (!data.length) { return; }
            let wb = { SheetNames: ['Report'], Sheets: {} };
            let wsData: any[][] = [];
            let headers = cols.map((c: any) => c.name);
            wsData.push(headers);
            data.forEach((row: any) => {
                let rowArr = cols.map((c: any) => row[c.prop] || '');
                wsData.push(rowArr);
            });
            let XLSX = require('xlsx');
            let ws = XLSX.utils.aoa_to_sheet(wsData);
            wb.Sheets['Report'] = ws;
            let fileName = 'ClientRefChangeReport_' + moment().format('DD-MM-YYYY_HH-mm-ss') + '.xlsx';
            XLSX.writeFile(wb, fileName);
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/clientRefChangeReport/clientRefChangeReport.component.ts